import { render, staticRenderFns } from "./DataScreenForm.vue?vue&type=template&id=f86bc582"
import script from "./DataScreenForm.vue?vue&type=script&lang=js"
export * from "./DataScreenForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/componenterpserver/gitrepo/unitmodeler/jp-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f86bc582')) {
      api.createRecord('f86bc582', component.options)
    } else {
      api.reload('f86bc582', component.options)
    }
    module.hot.accept("./DataScreenForm.vue?vue&type=template&id=f86bc582", function () {
      api.rerender('f86bc582', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modules/datav/DataScreenForm.vue"
export default component.exports